export * from "./CopyTextInput";
